import { useTranslate } from '@va/localization';
import { fontWeights, Paragraph } from '@va/ui/design-system';
import { useCallback } from 'react';

enum URLItemEnum {
  PROTOCOL = 'HTTPS://',
  DOMAIN = 'WWW.DOMAIN.COM',
  PATH = '/BLOG/',
  QUERYSTRING = '?ID=360',
  FRAGMENT = '#ARTICLE',
}

export const UrlStructureMobileTooltip = () => {
  const translate = useTranslate();

  const getUrlItem = useCallback(
    (text: URLItemEnum, name: string) => (
      <div className='flex justify-between items-center gap-5'>
        <Paragraph weight={fontWeights.medium}>{text}</Paragraph>
        <Paragraph weight={fontWeights.medium}>{name}</Paragraph>
      </div>
    ),
    [],
  );

  return (
    <div className='p-3'>
      <Paragraph weight={fontWeights.medium}>{translate('url.urlStructure')}:</Paragraph>
      {getUrlItem(URLItemEnum.PROTOCOL, translate('url.protocol'))}
      {getUrlItem(URLItemEnum.DOMAIN, translate('url.domain'))}
      {getUrlItem(URLItemEnum.PATH, translate('url.path'))}
      {getUrlItem(URLItemEnum.QUERYSTRING, translate('url.queryString'))}
      {getUrlItem(URLItemEnum.FRAGMENT, translate('url.fragment'))}
    </div>
  );
};

type UrlItemProps = {
  text: string;
  tooltipText: string;
};

export const UrlStructureItems = () => {
  const translate = useTranslate();
  return (
    <div className={'flex gap-1'}>
      <UrlItem text={URLItemEnum.PROTOCOL} tooltipText={translate('url.protocol')} />
      <UrlItem text={URLItemEnum.DOMAIN} tooltipText={translate('url.domain')} />
      <UrlItem text={URLItemEnum.PATH} tooltipText={translate('url.path')} />
      <UrlItem text={URLItemEnum.QUERYSTRING} tooltipText={translate('url.queryString')} />
      <UrlItem text={URLItemEnum.FRAGMENT} tooltipText={translate('url.fragment')} />
    </div>
  );
};

const UrlItem: React.FC<UrlItemProps> = ({ text, tooltipText }) => {
  return (
    <div className='flex flex-col items-center gap-2 flex-grow'>
      <div className='relative'>
        <Paragraph className='px-12px py-6px bg-primary text-white rounded-[0.5625rem]' weight={fontWeights.medium}>
          {tooltipText}
        </Paragraph>
        <div className='w-6px h-6px bg-primary rotate-45 absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2'></div>
      </div>
      <Paragraph
        className='py-12px px-18px rounded-12 w-full bg-white-snow text-gray-charcoal text-center'
        weight={fontWeights.medium}
      >
        {text}
      </Paragraph>
    </div>
  );
};
